import React, { useState, useEffect } from 'react';

import { useNavigate, Link, useParams } from 'react-router-dom';
import db from "./Firebase";
import firebaseApp from "./Firebase";
import { arrayUnion } from "firebase/firestore";
import { storage } from './Firebase';
import { ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";
import Moment from 'moment';
import { extendMoment } from 'moment-range';
import ViewAllRequests from './ViewAllRequests';
import ViewAppData from './ViewAppData';
import { CSVLink } from "react-csv";

function PortfolioFullData() {
    const navigate = useNavigate();
    const moment = extendMoment(Moment);
    const [data, setData] = useState([]);
    const [csvdata, setCsvdata] = useState([]);

    useEffect(() => {
        const storedUsername = localStorage.getItem("email");
        const storedPassword = localStorage.getItem("password");
        const storedRemember = localStorage.getItem("remember");

        if (storedRemember === "false" || !storedUsername || !storedPassword) {
            navigate('/signin');
        }
    }, []);


    const headers = [
        { label: "First Name", key: "first_name" },
        { label: "Last Name", key: "last_name" },
        { label: "Phone No", key: "phone_no" },
        { label: "Title/Designation", key: "title_designation" },
        { label: "City", key: "city" },
        { label: "State", key: "state" },
        { label: "Pincode", key: "pincode" },
        { label: "Parlour Name", key: "parlour_name" },
        { label: "Parlour Type", key: "parlour_type" },
        { label: "Username", key: "username" },
        { label: "Is Registered", key: "is_registered" },
        { label: "No Of Clients", key: "no_of_clients" },
        { label: "Willing to Travel", key: "willing_to_travel" },
        { label: "Working Science", key: "working_since" },
        { label: "Created Date", key: "created_date", dataFormat: "MM/DD/YY, h:mm a" },
    ];

    useEffect(() => {
        db.collection("portfolio_details").orderBy("created_date", "desc").onSnapshot((snapshot) => {
            setData(
                snapshot.docs.map((doc) => ({
                    id: doc.id,
                    data: doc.data(),
                }))
            );
            setCsvdata(
                snapshot.docs.map((doc) => {
                    const data = doc.data();
                    return {
                        ...data,
                        created_date: moment(data.created_date.toDate().toISOString()).format("MM/DD/YY, h:mm a"),
                    };
                })
            );
        });
    }, []);

    return (
        <>
            <main class="main-content position-relative max-height-vh-100 h-100 border-radius-lg">
                <div class="p-2" style={{ paddingBottom: "5px", display: "flex", justifyContent: "space-between" }}>
                    <Link to="/">
                        <img src="/images/menubutton.png" class="menu-toggle" alt="Responsive image" style={{ height: "2rem" }} />
                    </Link>
                    <CSVLink data={csvdata} headers={headers}>
                        <span class="btn bg-gradient-secondary btn-sm mb-0 mr-2" style={{ color: "white" }} >&nbsp; Download Excel</span>
                    </CSVLink>
                </div>
                <div class="">
                    <div class="p-2">
                        <div class="card">
                            <div class="card-header pb-0 px-3">
                                <h6 class="mb-2">Portfolio Data</h6>
                            </div>
                            <div class="card">
                                <div class="table-responsive fix-width scroll-inner">
                                    <table class="table table-bordered table-hover">
                                        <thead class="thead-dark" style={{ position: "sticky", top: "0" }}>
                                            <tr style={{ textAlign: "left" }}>
                                                <th class="col ps-2">Name</th>
                                                <th class="col">Phone No</th>
                                                <th class="col ps-2">Title/Designation</th>
                                                <th class="col ps-2">City</th>
                                                <th class="col ps-2">State</th>
                                                <th class="col ps-2">Pincode</th>
                                                <th class="col ps-2">Parlour Name</th>
                                                <th class="col ps-2">Parlour Type</th>
                                                <th class="col ps-2">Username</th>
                                                <th class="col ps-2">Is Registered</th>
                                                <th class="col ps-2">No Of Clients</th>
                                                <th class="col ps-2">Willing To Travel</th>
                                                <th class="col ps-2">Working Since</th>
                                                <th class="col ps-2">Created Date</th>
                                            </tr>
                                        </thead>
                                        <tbody style={{ textAlign: "left" }}>
                                            {data?.map(({ id, data }, index) => (
                                                <tr key={id}>
                                                    <td>
                                                        <p class="text-xs mb-0">{data.first_name} {data.last_name}</p>
                                                    </td>
                                                    <td>
                                                        <p class="text-xs mb-0">{data.phone_no}</p>
                                                    </td>
                                                    <td>
                                                        <p class="text-xs mb-0">{data.title_designation}</p>
                                                    </td>
                                                    <td>
                                                        <p class="text-xs mb-0">{data.city}</p>
                                                    </td>
                                                    <td>
                                                        <p class="text-xs mb-0">{data.state}</p>
                                                    </td>
                                                    <td>
                                                        <p class="text-xs mb-0">{data.pincode}</p>
                                                    </td>
                                                    <td>
                                                        <p class="text-xs mb-0">{data.parlour_name}</p>
                                                    </td>
                                                    <td>
                                                        <p class="text-xs mb-0">{data.parlour_type}</p>
                                                    </td>
                                                    <td>
                                                        <p class="text-xs mb-0">{data.username}</p>
                                                    </td>
                                                    <td>
                                                        <p class="text-xs mb-0">{data.is_registerd}</p>
                                                    </td>

                                                    <td>
                                                        <p class="text-xs mb-0">{data.no_of_clients}</p>
                                                    </td>
                                                    <td>
                                                        <p class="text-xs mb-0">{data.willing_to_travel}</p>
                                                    </td>

                                                    <td>
                                                        <p class="text-xs mb-0">{data.working_since}</p>
                                                    </td>
                                                    <td>
                                                        <div class="d-flex px-2 py-1">
                                                            <div class="d-flex flex-column justify-content-center">
                                                                <h6 class="mb-0 text-xs">{moment(data.created_date.toDate().toISOString()).format("MM/DD/YY, h:mm a")}</h6>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
}

export default PortfolioFullData;
